import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Button, Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import './formularioTarefas.css';
import {
  selectFormAtividades,
  DropdownIndicator,
} from '~/Styles/reactSelectStyles';
import DateMask from '../DateMask';
import MaskedInput from 'react-text-mask';
import { useSelector } from 'react-redux';
import { PROVEDOR_CALENDARIO_EXTERNO, TIPO_ATIVIDADE } from '~/constant';
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import Loading from '../Loading';
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import AuthStorage from '~/Utils/AuthStorage';
import { FaChevronDown, FaWindowClose } from 'react-icons/fa';
import Anotacao from '../Anotacao/anotacao';
import Email from '../Email/email';
import moment from 'moment';
import { TextField } from '@material-ui/core';

const TaskFormSchema = Yup.object().shape({
  data: Yup.string()
    .nullable()
    .required('A Data de conclusão é obrigatória'),
  descricao: Yup.string().required('Descrição é obrigatória'),
  prioridade: Yup.string().required('Prioridade é obrigatória'),
  situacao: Yup.string().required('Situação é obrigatória'),
  tipoResponsavel: AuthStorage.isCorretor()
    ? Yup.string()
    : Yup.string().required('Tipo de Responsável é obrigatório'),
  responsavel: AuthStorage.isCorretor()
    ? Yup.string()
    : Yup.string().required('Responsável é obrigatório'),
  lembreteEmail: Yup.string().required('Envio de lembrete é obrigatório'),
});

const FormularioTarefas = ({
  onSubmit,
  initialValues,
  modoEdicao,
  readOnly = false,
  salvandoDados,
  closeModal,
  modoInternoDaAnotacao = { exibir: false, incluido: '' },
  atividadeVinculada,
}) => {
  const [buscandoDados, setBuscandoDados] = useState(false);
  const [responsavelOptions, setResponsavelOptions] = useState(null);
  const [atendentesOptions, setAtendentesOptions] = useState(null);
  const [optionsCorretores, setOptionsCorretores] = useState(
    useSelector(state => state.corretor).listaCorretores.map(cor => ({
      value: cor.codigo + ' - ' + cor.nome,
      label: cor.nome,
    }))
  );
  const [exibirAtividadeVinculada, setExibirAtividadeVinculada] = useState(
    false
  );
  const isIOS = () => {
    if (typeof navigator === 'undefined') return false;

    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  };

  const buscarAtendentes = async () => {
    try {
      setBuscandoDados(true);
      let response = await api.getAtendentesCAV();
      if (response) {
        const options = response.map(pdv => ({
          value: pdv.codigo + ' - ' + pdv.descricao,
          label: pdv.descricao,
        }));

        setAtendentesOptions(options);

        if (modoEdicao && initialValues.tipoResponsavel) {
          switch (initialValues.tipoResponsavel) {
            case 'Atendente':
              setResponsavelOptions(options);
              break;
            case 'Corretor':
              setResponsavelOptions(optionsCorretores);
              break;
          }
        }
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setBuscandoDados(false);
    }
  };

  useEffect(() => {
    console.log('is ios: ', isIOS());
    buscarAtendentes();
  }, []);

  const prioridadeOptions = [
    { value: 'Alta', label: 'Alta' },
    { value: 'Normal', label: 'Normal' },
    { value: 'Baixa', label: 'Baixa' },
  ];

  const situacaoOptions = [
    { value: 'Pendente', label: 'Pendente' },
    { value: 'Concluído', label: 'Concluído' },
    { value: 'Em Andamento', label: 'Em Andamento' },
    { value: 'Cancelado', label: 'Cancelado' },
    { value: 'Vencido', label: 'Vencido' },
  ];

  const tipoResponsavelOptions = [
    { value: 'Atendente', label: 'Atendente' },
    { value: 'Corretor', label: 'Corretor' },
  ];

  const lembreteEmailOptions = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
  ];

  const montarDadosSubmit = values => {
    const dadosSubmit = { ...values };

    if (AuthStorage.isCorretor()) {
      dadosSubmit.tipoResponsavel = 'Corretor';
      dadosSubmit.responsavel =
        AuthStorage.getUser().usuario + ' - ' + AuthStorage.getUser().nome;
    }

    return dadosSubmit;
  };

  const salvarFormularioSemAgendaExterna = values => {
    const dadosSubmit = montarDadosSubmit(values);

    onSubmit({
      ...dadosSubmit,
      sincronizarCalendario: PROVEDOR_CALENDARIO_EXTERNO.NENHUM,
    });
  };

  const buildFormAtividadeVinculada = atividade => {
    const atividadeDetalheObj = JSON.parse(atividade.atividade);

    switch (atividade.tipo_atividade) {
      case TIPO_ATIVIDADE.ANOTACAO:
        return (
          <Anotacao
            initialValues={{ ...atividadeDetalheObj }}
            readOnly={true}
            hiddenSubmit={true}
          />
        );
      case TIPO_ATIVIDADE.SMS:
        return (
          <Anotacao
            initialValues={{ ...atividadeDetalheObj }}
            readOnly={true}
            hiddenSubmit={true}
          />
        );
      case TIPO_ATIVIDADE.EMAIL:
        return (
          <Email
            initialValues={{ ...atividadeDetalheObj }}
            readOnly={true}
            hiddenSubmit={true}
          />
        );
    }
  };

  return (
    <>
      {!buscandoDados && (
        <Formik
          initialValues={initialValues}
          validationSchema={TaskFormSchema}
          onSubmit={salvarFormularioSemAgendaExterna}
        >
          {({ errors, touched, setFieldValue, values, handleSubmit }) => (
            <Form className="mt-3" onSubmit={handleSubmit}>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <label className="label-form-tarefas">Descrição</label>
                    <input
                      name="descricao"
                      type="text"
                      value={values.descricao}
                      onChange={e => setFieldValue('descricao', e.target.value)}
                      className={`form-control ${
                        errors.descricao && touched.descricao
                          ? 'is-invalid'
                          : ''
                      }`}
                      readOnly={readOnly}
                    />
                    {errors.descricao && touched.descricao && (
                      <div className="invalid-feedback">{errors.descricao}</div>
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <div className="form-group">
                      <label className="label-form-tarefas">Data e Hora</label>
                      <div className="pb-2 d-flex align-items-center">
                        {!isIOS() ? (
                          <KeyboardDateTimePicker
                            style={{
                              display: 'block',
                              width: '100%',
                              height: 'calc(1.5em + 0.75rem + 2px)',
                              padding: '0.375rem 0.75rem',
                              fontSize: '1rem',
                              fontWeight: 400,
                              lineHeight: 1.5,
                              color: '#495057',
                              backgroundColor: '#fff',
                              backgroundClip: 'padding-box',
                              border: '1px solid #ced4da',
                              borderRadius: '0.25rem',
                            }}
                            clearable
                            clearLabel="limpar"
                            showTodayButton={true}
                            todayLabel="agora"
                            cancelLabel="cancelar"
                            invalidDateMessage="Data inválida"
                            ampm={false}
                            name="data"
                            value={values.data || null}
                            onChange={date => {
                              if (date) {
                                setFieldValue(
                                  'data',
                                  date.format('YYYY-MM-DD HH:mm')
                                );
                              } else {
                                setFieldValue('data', null);
                              }
                            }}
                            format="DD/MM/YYYY HH:mm"
                            disabled={readOnly}
                            fullWidth
                          />
                        ) : (
                          <TextField
                            type="datetime-local"
                            value={
                              values.data
                                ? moment(values.data).format('YYYY-MM-DDTHH:mm')
                                : ''
                            }
                            onChange={e => {
                              const inputValue = e.target.value;
                              if (!inputValue) {
                                setFieldValue('data', null);
                                return;
                              }

                              const parsed = moment(
                                inputValue,
                                'YYYY-MM-DDTHH:mm',
                                true
                              );
                              setFieldValue(
                                'data',
                                parsed.isValid()
                                  ? parsed.format('YYYY-MM-DD HH:mm')
                                  : null
                              );
                            }}
                            fullWidth
                            disabled={readOnly}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              style: {
                                fontSize: '1rem',
                                fontWeight: 400,
                                lineHeight: 1.5,
                                color: '#495057',
                                padding: '0.375rem 0.75rem',
                              },
                            }}
                            style={{
                              backgroundColor: readOnly ? '#e9ecef' : '#fff',
                              border: '1px solid #cccccc',
                              borderRadius: '0.25rem',
                              height: 'calc(1.5em + 0.75rem + 2px)',
                              padding: '0.5rem 0.75rem',
                              fontSize: '1rem',
                              fontWeight: 400,
                              lineHeight: 1,
                              color: '#495057',
                              backgroundColor: '#fff',
                            }}
                          />
                        )}
                      </div>

                      {errors.data && touched.data && (
                        <div className="invalid-feedback d-block">
                          {errors.data}
                        </div>
                      )}
                    </div>
                  </MuiPickersUtilsProvider>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-tarefas">Prioridade</label>
                    <Select
                      options={prioridadeOptions}
                      onChange={option =>
                        setFieldValue('prioridade', option.value)
                      }
                      className={`react-select ${
                        errors.prioridade && touched.prioridade
                          ? 'is-invalid'
                          : ''
                      }`}
                      value={
                        prioridadeOptions.find(
                          opt => opt.value === values.prioridade
                        ) || null
                      }
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isSearchable={false}
                      placeholder={'Selecione a prioridade...'}
                      isDisabled={readOnly}
                    />
                    {errors.prioridade && touched.prioridade && (
                      <div className="invalid-feedback">
                        {errors.prioridade}
                      </div>
                    )}
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-tarefas">Situação</label>
                    <Select
                      options={situacaoOptions}
                      onChange={option =>
                        setFieldValue('situacao', option.value)
                      }
                      className={`react-select ${
                        errors.situacao && touched.situacao ? 'is-invalid' : ''
                      }`}
                      value={
                        situacaoOptions.find(
                          opt => opt.value === values.situacao
                        ) || null
                      }
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isSearchable={false}
                      placeholder={'Selecione a situação...'}
                      isDisabled={readOnly}
                    />
                    {errors.situacao && touched.situacao && (
                      <div className="invalid-feedback">{errors.situacao}</div>
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-tarefas">
                      Tipo de Responsável
                    </label>
                    <Select
                      options={tipoResponsavelOptions}
                      onChange={option => {
                        setFieldValue('tipoResponsavel', option.value);
                        if (option.value === 'Corretor') {
                          setResponsavelOptions(optionsCorretores);
                        } else if (option.value === 'Atendente') {
                          setResponsavelOptions(atendentesOptions);
                        }
                      }}
                      className={`react-select ${
                        errors.tipoResponsavel && touched.tipoResponsavel
                          ? 'is-invalid'
                          : ''
                      }`}
                      value={
                        AuthStorage.isCorretor()
                          ? { value: 'Corretor', label: 'Corretor' }
                          : tipoResponsavelOptions.find(
                              opt => opt.value === values.tipoResponsavel
                            ) || null
                      }
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isSearchable={false}
                      placeholder={'Selecione o responsável...'}
                      isDisabled={readOnly || AuthStorage.isCorretor()}
                    />
                    {errors.tipoResponsavel && touched.tipoResponsavel && (
                      <div className="invalid-feedback">
                        {errors.tipoResponsavel}
                      </div>
                    )}
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-tarefas">Responsável</label>
                    <Select
                      options={responsavelOptions ? responsavelOptions : []}
                      onChange={option =>
                        setFieldValue('responsavel', option.value)
                      }
                      className={`react-select ${
                        errors.responsavel && touched.responsavel
                          ? 'is-invalid'
                          : ''
                      }`}
                      value={
                        AuthStorage.isCorretor()
                          ? {
                              value:
                                AuthStorage.getUser().usuario +
                                ' - ' +
                                AuthStorage.getUser().nome,
                              label: AuthStorage.getUser().nome,
                            }
                          : responsavelOptions
                          ? responsavelOptions.find(
                              opt => opt.value === values.responsavel
                            ) || null
                          : null
                      }
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isSearchable={false}
                      placeholder={'Selecione o responsável...'}
                      isDisabled={readOnly || AuthStorage.isCorretor()}
                    />
                    {errors.responsavel && touched.responsavel && (
                      <div className="invalid-feedback">
                        {errors.responsavel}
                      </div>
                    )}
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-tarefas">
                      Lembrete de tarefa por e-mail
                    </label>
                    <Select
                      options={lembreteEmailOptions}
                      onChange={option =>
                        setFieldValue('lembreteEmail', option.value)
                      }
                      className={`react-select ${
                        errors.lembreteEmail && touched.lembreteEmail
                          ? 'is-invalid'
                          : ''
                      }`}
                      value={
                        lembreteEmailOptions.find(
                          opt => opt.value === values.lembreteEmail
                        ) || null
                      }
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isSearchable={false}
                      placeholder={'Selecione...'}
                      isDisabled={readOnly}
                    />
                    {errors.lembreteEmail && touched.lembreteEmail && (
                      <div className="invalid-feedback">
                        {errors.lembreteEmail}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>

              {atividadeVinculada && atividadeVinculada.codigo_atividade > 0 && (
                <div className="mb-3">
                  <div
                    className="d-flex align-items-center justify-content-between p-3 rounded"
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                    }}
                    onClick={() =>
                      setExibirAtividadeVinculada(!exibirAtividadeVinculada)
                    }
                  >
                    <div className="d-flex align-items-center">
                      <span
                        style={{
                          color: '#495057',
                          fontWeight: '500',
                          fontSize: '14px',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        Exibir Atividade Vinculada
                      </span>
                    </div>
                    <div
                      style={{
                        transform: exibirAtividadeVinculada
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    >
                      <FaChevronDown
                        style={{ color: '#6c757d', fontSize: '12px' }}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      maxHeight: exibirAtividadeVinculada ? '1000px' : '0px',
                      overflow: exibirAtividadeVinculada ? 'visible' : 'hidden',
                      transition: 'max-height 0.3s ease-in-out',
                      backgroundColor: '#fff',
                      border: exibirAtividadeVinculada
                        ? '1px solid #e9ecef'
                        : 'none',
                      borderRadius: '0 0 0.375rem 0.375rem',
                      position: 'relative',
                      zIndex: 99998,
                    }}
                  >
                    {exibirAtividadeVinculada &&
                      buildFormAtividadeVinculada(atividadeVinculada)}
                  </div>
                </div>
              )}
              <hr className="my-4" />
              <div className="d-flex justify-content-end">
                <Button
                  className={
                    modoInternoDaAnotacao.exibir &&
                    modoInternoDaAnotacao.incluido
                      ? 'btn-danger-color'
                      : 'btn-light-color'
                  }
                  size="sm"
                  type="submit"
                  disabled={
                    readOnly ||
                    salvandoDados ||
                    (modoInternoDaAnotacao.exibir &&
                      modoInternoDaAnotacao.incluido)
                  }
                >
                  {modoInternoDaAnotacao.exibir ? (
                    modoInternoDaAnotacao.incluido ? (
                      <>Incluído</>
                    ) : (
                      <>Incluir</>
                    )
                  ) : (
                    <>Salvar</>
                  )}
                </Button>
                {!modoInternoDaAnotacao.exibir && (
                  <Button
                    variant="light"
                    size="sm"
                    type="button"
                    className="d-inline-flex align-items-center ml-2"
                    onClick={closeModal}
                    disabled={salvandoDados}
                  >
                    <FaWindowClose />
                    <span className="ml-2 d-xs-none">Fechar</span>
                  </Button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      )}

      {buscandoDados && (
        <div>
          <Loading label="Buscando dados..." />
        </div>
      )}

    </>
  );
};

export default FormularioTarefas;
